import {

  GET_PAGE_DEFINITIONS_SUCCESS,
  ADD_PAGE_DEFINITION_SUCCESS,
  UPDATE_PAGE_DEFINITION_SUCCESS,
  DELETE_PAGE_DEFINITION_SUCCESS,
  PAGE_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [], //Model Data ve Error
  error: {},
}

const pageDefinition = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_PAGE_DEFINITIONS_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
      }

    case ADD_PAGE_DEFINITION_SUCCESS:
      return {
        ...state,
        recordList: [...state.recordList, action.payload],
      }

    case UPDATE_PAGE_DEFINITION_SUCCESS:
      return {
        ...state,
        recordList: state.recordList.map(record =>
          record.guid.toString() === action.payload.guid.toString()
            ? { record, ...action.payload }
            : record
        ),
      }

    case DELETE_PAGE_DEFINITION_SUCCESS:
      return {
        ...state,
        recordList: state.recordList.filter(
          record => record.guid.toString() !== action.payload.toString()
        ),
      }

    case PAGE_API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false 
        }
    default:

      return state

  }
}

export default pageDefinition